import railsUjsCode from '../../../node_modules/@rails/ujs/lib/assets/compiled/rails-ujs.js?raw'

const fn = new Function(railsUjsCode)
fn.call(window)

const Rails = window.Rails

export default Rails
